/* COTZA theme scripts */
(function () {
  document.documentElement.classList.remove('no-js');
  if (document.readyState === 'complete') document.documentElement.classList.add('is-loaded');
  else window.addEventListener('load', () => document.documentElement.classList.add('is-loaded'));
  const T = Object.assign({ currency: 'EGP', addToCart: 'Add to cart', soldOut: 'Sold out', save: 'Save __PCT__%', perPair: '__PRICE__ / pair', addError: 'Could not add to cart.' }, window.cotzaStrings || {});

  /* ---------- Drawers ---------- */
  const openDrawer = (drawer) => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    const focusable = drawer.querySelector('[data-drawer-close]');
    if (focusable) focusable.focus();
  };
  const closeDrawer = (drawer) => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.drawer.is-open')) document.body.classList.remove('is-locked');
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      const drawer = document.getElementById(opener.getAttribute('data-drawer-open'));
      if (drawer) {
        event.preventDefault();
        openDrawer(drawer);
      }
      return;
    }
    const closer = event.target.closest('[data-drawer-close]');
    if (closer) closeDrawer(closer.closest('.drawer'));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Header over the hero ---------- */
  const header = document.querySelector('.site-header');
  if (header && document.body.classList.contains('has-hero')) {
    const update = () => header.classList.toggle('is-transparent', window.scrollY < 40);
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ---------- Reveal on scroll ---------- */
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-qty-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('input');
    const next = Math.max(Number(input.min || 0), (Number(input.value) || 0) + Number(step.dataset.qtyStep));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart ---------- */
  const cartDrawer = document.getElementById('CartDrawer');

  const renderCart = async (sectionsHtml) => {
    let html = sectionsHtml;
    if (!html) {
      const res = await fetch(`${window.routes.root_url.replace(/\/$/, '')}/?sections=cart-drawer`);
      html = (await res.json())['cart-drawer'];
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-contents]');
    const current = document.querySelector('[data-cart-contents]');
    if (fresh && current) current.replaceWith(fresh);
    const count = doc.querySelector('[data-cart-count-value]');
    if (count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count.dataset.cartCountValue === '0' ? '' : count.dataset.cartCountValue;
      });
    }
  };

  const changeLine = async (line, quantity) => {
    const contents = document.querySelector('[data-cart-contents]');
    if (contents) contents.classList.add('is-loading');
    try {
      const res = await fetch(`${window.routes.cart_change_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: ['cart-drawer'] })
      });
      const data = await res.json();
      if (document.body.classList.contains('template-cart')) {
        window.location.reload();
        return;
      }
      await renderCart(data.sections && data.sections['cart-drawer']);
    } finally {
      const after = document.querySelector('[data-cart-contents]');
      if (after) after.classList.remove('is-loading');
    }
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-line-qty]');
    if (input) changeLine(Number(input.dataset.cartLineQty), Math.max(0, Number(input.value) || 0));
  });
  /* Swap a cart line for the next bigger pack in one request */
  document.addEventListener('click', async (event) => {
    const upgrade = event.target.closest('[data-cart-upgrade]');
    if (!upgrade) return;
    upgrade.disabled = true;
    const contents = document.querySelector('[data-cart-contents]');
    if (contents) contents.classList.add('is-loading');
    try {
      const updates = { [upgrade.dataset.from]: 0, [upgrade.dataset.to]: Number(upgrade.dataset.toQty) };
      const res = await fetch(`${window.routes.cart_url}/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections: ['cart-drawer'] })
      });
      const data = await res.json();
      if (document.body.classList.contains('template-cart')) {
        window.location.reload();
        return;
      }
      await renderCart(data.sections && data.sections['cart-drawer']);
    } finally {
      const after = document.querySelector('[data-cart-contents]');
      if (after) after.classList.remove('is-loading');
    }
  });
  document.addEventListener('click', (event) => {
    const remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    changeLine(Number(remove.dataset.cartRemove), 0);
  });

  /* ---------- Product form ---------- */
  document.querySelectorAll('[data-product] form[action*="/cart/add"]').forEach((form) => {
    const root = form.closest('[data-product]');
    const variantsJson = root && root.querySelector('[data-product-variants]');
    const variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
    const idInput = form.querySelector('input[name="id"]');
    const submit = form.querySelector('[type="submit"]');
    const priceEl = root.querySelector('[data-price]');
    const compareEl = root.querySelector('[data-compare-price]');
    const perPairEl = root.querySelector('[data-per-pair]');
    const errorEl = root.querySelector('[data-form-error]');

    const formatMoney = (cents) => {
      const value = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
      return `${value} ${T.currency}`;
    };

    const selectVariant = (radio) => {
      const variant = variants.find((v) => String(v.id) === radio.value);
      if (!variant) return;
      idInput.value = variant.id;
      root.querySelectorAll('[data-variant-radio]').forEach((r) => {
        const card = r.closest('.pack');
        if (card) card.classList.toggle('is-selected', r === radio);
      });
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      const discounted = variant.compare_at_price > variant.price;
      if (compareEl) compareEl.textContent = discounted ? formatMoney(variant.compare_at_price) : '';
      const badge = root.querySelector('[data-save-badge]');
      if (badge) {
        badge.textContent = discounted
          ? T.save.replace('__PCT__', Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price))
          : '';
      }
      const pairs = parseInt(radio.dataset.pairs, 10);
      if (perPairEl) perPairEl.textContent = pairs ? T.perPair.replace('__PRICE__', `${Math.round(variant.price / pairs / 100)} ${T.currency}`) : '';
      const summary = root.querySelector('[data-pack-summary]');
      if (summary) summary.textContent = radio.dataset.summary || '';
      submit.disabled = !variant.available;
      submit.querySelector('span').textContent = variant.available
        ? `${T.addToCart} · ${formatMoney(variant.price)}`
        : T.soldOut;
      return variant;
    };

    root.querySelectorAll('[data-variant-radio]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const variant = selectVariant(radio);
        if (!variant) return;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
        if (variant.featured_media) {
          const thumb = root.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
          if (thumb) thumb.click();
        }
      });
    });

    form.addEventListener('submit', async (event) => {
      if (!cartDrawer) return;
      event.preventDefault();
      if (errorEl) errorEl.textContent = '';
      submit.classList.add('is-loading');
      try {
        const body = new FormData(form);
        body.append('sections', 'cart-drawer');
        body.append('sections_url', window.location.pathname);
        const res = await fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body
        });
        const data = await res.json();
        if (data.status) {
          if (errorEl) errorEl.textContent = data.description || data.message || T.addError;
          return;
        }
        await renderCart(data.sections && data.sections['cart-drawer']);
        openDrawer(cartDrawer);
      } catch (e) {
        form.submit();
      } finally {
        submit.classList.remove('is-loading');
      }
    });
  });

  /* ---------- Product gallery ---------- */
  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-media-id]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-gallery]');
    const main = gallery.querySelector('[data-gallery-main]');
    main.src = thumb.dataset.src;
    main.alt = thumb.dataset.alt || '';
    gallery.querySelectorAll('[data-media-id]').forEach((t) => t.setAttribute('aria-current', String(t === thumb)));
  });
})();
